/**
 *
 * Service are used to access acf services(internal js API) and Rest Serive
 *
 * @module geo/services
 * @preferred
 * @since 2.1.0
 */
import {Store} from 'redux';

import { ServiceAction} from '../types/services';

import {AppStore} from '../store/app';
import { uuid } from '../utils/uuid';

/**
 * @since 2.1.0
 */
export abstract class Service {
  public store: Store<AppStore>;

  /**
   * unique Id for service instance
   * @internalapi
   * @private
   */
  public serviceId: string;

  constructor(options: any, serviceId: string) {
    Object.assign(this, options);

    this.store = options.store;
    this.serviceId = serviceId;
  }

  public getIdAndTransient(option:Partial<ServiceAction>){
    let id:string='';
    if (!option.id) {
      id = uuid();
    } else {
      id = option.id;
    }
    let transient=false;
    if(option.transient==undefined){
      transient=false;
    }else{
      transient =option.transient;
    }
    return {
      id,
      transient
    }
  }

 
}
